export const MENU = {
  CMS: 'cms',
  USAGE_AND_LIMITS: 'usage & limits',
  ACCOUNT: 'account',
  SETTINGS: 'settings',
};
